<template>
  <div class="table1">
    <table width="width" border="1">
      <tr class="backColorHui">
        <td class="color333">债券名称</td>
        <td class="Width2">宁波建工股份有限公司公开发行可转...</td>
        <td class="color333">相关正股</td>
        <td class="Width2 colorBlue">宁波建工 - 601789</td>
        <td class="color333">正股涨跌</td>
        <td class="Width2 colorRed">7.04 + 3.53%</td>
      </tr>
      <tr class="backColorWhite">
        <td class="color333">转债占比</td>
        <td class="Width2">6.88%</td>
        <td class="color333">转股价</td>
        <td class="Width2">4.760</td>
        <td class="color333">正股市净率</td>
        <td class="Width2">1.84</td>
      </tr>
      <tr class="backColorHui">
        <td class="color333">正股波动率</td>
        <td class="Width2">6.88%</td>
        <td class="color333">纯债价值</td>
        <td class="Width2">98.44</td>
        <td class="color333">期权价值</td>
        <td class="Width2 colorYellow">会员</td>
      </tr>
      <tr class="backColorWhite">
        <td class="color333">债券评级</td>
        <td class="Width2">AA</td>
        <td class="color333">发行规模（亿）</td>
        <td class="Width2">6.700亿</td>
        <td class="color333">剩余规模（亿）</td>
        <td class="Width2">1.84</td>
      </tr>
      <tr class="backColorHui">
        <td class="color333">回售触发价</td>
        <td class="Width2">6.47</td>
        <td class="color333">强赎触发价</td>
        <td class="Width2">6.47</td>
        <td class="color333">到期赎回价</td>
        <td class="Width2">100.00</td>
      </tr>
      <tr class="backColorWhite">
        <td class="color333">基金持仓</td>
        <td class="Width2">0.13%</td>
        <td class="color333">回售价</td>
        <td class="Width2">100.00</td>
        <td class="color333">转股起始日</td>
        <td class="Width2">021-01-11</td>
      </tr>
      <tr class="backColorHui">
        <td class="color333">已转股比例</td>
        <td class="Width2">12.46%</td>
        <td class="color333">回售起始日</td>
        <td class="Width2">2024-07-05</td>
        <td class="color333">回售税前收益</td>
        <td class="Width2">100.00</td>
      </tr>
      <tr class="backColorWhite">
        <td class="color333">回售剩余年限</td>
        <td class="Width2">1574天</td>
        <td class="color333">质押代码</td>
        <td class="Width2">123036</td>
        <td class="color333">到期时间</td>
        <td class="Width2">2027-03-11</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.table1 {
  margin-top: 24px;
  
}
table {
  border-collapse: collapse;
  border-color: #e9ebf3;
}
td {
  width: 122px;
  height: 16px;
  padding: 20px;
  font-size: 16px;
  letter-spacing: 0px;
  color: #666666;
}
.Width2 {
  width: 323px;
}
@import url('../../../../public/css/public.css')
</style>